import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders} from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';

import { Usuario } from '@/Interfaces';
import { AlertaService } from './alertaService';
import { STResponse } from '@/Interfaces/general/STRespons';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';
@Injectable({ providedIn: 'root' })
export class AutenticacionService {
    private currentUserSubject: BehaviorSubject<Usuario>;
    public currentUser: Observable<Usuario>;
    urlApiOficinaVirtual:String = null;

    constructor(private http: HttpClient,
        private alertService: AlertaService,
        private SpinnerService  : NgxSpinnerService,
        private router :Router, private global : GlobalService) {
        this.currentUserSubject = new BehaviorSubject<Usuario>(JSON.parse(sessionStorage.getItem('currentUser')));
        this.currentUser = this.currentUserSubject.asObservable();
    }

    public get currentUserValue(): Usuario {
      
        return this.currentUserSubject.value;
    }
    private get(metodo: string){
        if (this.urlApiOficinaVirtual == null){
          this.urlApiOficinaVirtual = JSON.parse(sessionStorage.getItem('configOficina')).urlApiOficinaVirtual;
        }
        return this.http.get(`${ this.urlApiOficinaVirtual }${ metodo }`);
    }
    private post(metodo:string, body: any, auth:boolean, token?:string){
      
      if (this.urlApiOficinaVirtual == null){
        this.urlApiOficinaVirtual = JSON.parse(sessionStorage.getItem('configOficina')).urlApiOficinaVirtual;
      }
        if(auth){
          let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'bearer '+ token });
            let options = { headers: headers };
            
            return this.http.post(`${ this.urlApiOficinaVirtual }${ metodo }`, body, options);
        }else{
          return this.http.post(`${ this.urlApiOficinaVirtual }${ metodo }`, body);
        }
      }
    login(tipoUsuario :number,tipoIdEmpleador:string,IdEmpleador:string, tipoIdUsuario:string, IdUsuario:string, CodigoAsesor:string, Clave:string ) {
        return new Promise((resolve,reject) =>{ 
            try{
              let paramsRoute = {
                "tipoUsuario":tipoUsuario,
	              "tipoIdEmpleador":tipoIdEmpleador,
	              "IdEmpleador":IdEmpleador,
	              "tipoIdUsuario":tipoIdUsuario,
	              "IdUsuario":IdUsuario,
	              "CodigoAsesor":CodigoAsesor,
	              "Clave":Clave
              }
              this.post('Login/Login',paramsRoute,false).subscribe((response: STResponse) =>{
                if(!response.error){  
                  resolve(response);
                }else{
                  reject(response);
                }
              },
              (exception)=>{
                
              }
              );
            } 
            catch(ex) {
              this.SpinnerService.hide();
              reject(ex);
            }
          });
          
    }
    JWTCreate(Token :number) {
      return new Promise((resolve,reject) =>{ 
          try{
            let paramsRoute = {
              "Token":Token,
              "Origen":'OficinaVirtual'
            }
            this.post('Login/CreateJWT',paramsRoute,false).subscribe((response: STResponse) =>{
              if(!response.error){  
                resolve(response);
              }else{
                reject(response);
              }
            },
            (exception)=>{
              
            }
            );
          } 
          catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
          }
        });
        
  }
    //Se carga los tipos de documentos Usuarios
    GettipoDocumento(Perfil:string){
        return new Promise((resolve,reject) =>{ 
            try{
               //
                this.get('General/TipoDocumento?Perfil='+Perfil)
                .subscribe((response: STResponse) =>{
                    if(!response.error){
                        resolve(response);
                    }else{
                        reject(response);
                    }
                })
            } 
            catch(ex) {
                this.SpinnerService.hide();
                reject(ex);
                this.alertService.error(ex,false);
            }
          });
    }
    //Se carga la lista de Departamentos
    GetDepartamentos(){
      return new Promise((resolve,reject) =>{ 
        try{
           //
            this.get('General/Departamento')
            .subscribe((response: STResponse) =>{
                if(!response.error){
                    resolve(response);
                }else{
                    reject(response);
                }
            })
        } 
        catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
            this.alertService.error(ex,false);
        }
      });
    }
    //Se carga la lista de Ciudades por Departamentos
    GetCiudades(CodDepartamento:string ){
      return new Promise((resolve,reject) =>{ 
        try{
           //
            this.get('General/Ciudades?CodDepartamento='+CodDepartamento)
            .subscribe((response: STResponse) =>{
                if(!response.error){
                    resolve(response);
                }else{
                    reject(response);
                }
            })
        } 
        catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
            this.alertService.error(ex,false);
        }
      });
    }
    
    //Se carga el Menu que tiene acceso cada usuario
    GetMenu(IdUser:number, Token:string){
      return new Promise((resolve,reject) =>{ 
        try{
          let paramsRoute = {
            "IdUsuario":IdUser           
          }
          this.post('Menu/Menu',paramsRoute,true,Token).subscribe(
            (response: STResponse) =>{
              
            if(!response.error){  
              resolve(response);
              
            }else{
              reject(response);
            }
          },
          (reject)=>{
            return(reject);
          });
        } 
        catch(ex) {
          this.SpinnerService.hide();
          reject(ex);
        }
      });
    }
    ///Se carga el MenuPAC que tiene acceso cada usuario PAC
    GetMenuPAC(IdUser:number, Token:string){
      return new Promise((resolve,reject) =>{ 
        try{
          let paramsRoute = {
            "IdUsuario":IdUser           
          }
          this.post('Menu/MenuPAC',paramsRoute,true,Token).subscribe(
            (response: STResponse) =>{
              
            if(!response.error){  
              resolve(response);
              
            }else{
              reject(response);
            }
          },
          (reject)=>{
            return(reject);
          });
        } 
        catch(ex) {
          this.SpinnerService.hide();
          reject(ex);
        }
      });
    }
    /**
     * Método que realiza una petición HTTP de tipo POST
     * JoseMaH
     * @param metodo Nombre del método a consultar
     */
    RecordarClave(idPerfil :string,tipoDocumentoIdPadre:string,documentoIdPadre:string, tipoDocumentoId:string, documentoId:string, CanalventaId:string) {
      return new Promise((resolve,reject) =>{ 
          try{
            let paramsRoute = { 
              "idPerfil":idPerfil,
              "tipoDocumentoIdPadre":tipoDocumentoIdPadre,
              "documentoIdPadre":documentoIdPadre,
              "tipoDocumentoId":tipoDocumentoId,
              "documentoId":documentoId,
              "CanalventaId":CanalventaId
            }
            this.post('RecordarContraseña/RecordarClave',paramsRoute,false).subscribe((response: STResponse) =>{
              if(!response.error){  
                resolve(response);
              }else{
                reject(response);
              }
            },
            (exception)=>{ 
              
            }
            );
          } 
          catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
          }
        });
    }

    CambiarClave(idUsuario:string,IdCambio:string, clave:string) {
      return new Promise((resolve,reject) =>{ 
          try{
            let paramsRoute = { 
              "idUsuario":idUsuario,
              "idCambio":IdCambio,
              "clave":clave
            }
            this.post('CambiarClave/CambioClave',paramsRoute,false).subscribe((response: STResponse) =>{
              if(!response.error){  
                resolve(response);
              }else{
                reject(response);
              }
            },
            (exception)=>{
              
            }
            );
          } 
          catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
          }
        });
    }

    /**
     * Método que realiza una petición HTTP de tipo GET
     * ClaudiaFV
     * @param idPerfil
     * @param tipoDocumentoId
     * @param documentoId
     * @param tipoDocumentoIdPadre
     * @param documentoIdPadre
     * @param canalventaId
     * @param esSMS
     */
    GenerarPIN(idPerfil:string,tipoDocumentoId:string,documentoId:string,tipoDocumentoIdPadre:string,documentoIdPadre:string,canalventaId:string,esSMS:boolean) {
      return new Promise((resolve,reject) =>{ 
        try{
          this.get(`RecordarContraseña/GenerarClaveTemp?idPerfil=${idPerfil}&tipoDocumentoId=${tipoDocumentoId}&documentoId=${documentoId}&tipoDocumentoIdPadre=${tipoDocumentoIdPadre}&documentoIdPadre=${documentoIdPadre}&canalventaId=${canalventaId}&esSMS=${esSMS}`).subscribe(
            (response: any) =>{
              resolve(response);
          },
          (exception)=>{ 
            
          }
          );
        } 
        catch(ex) {
          this.SpinnerService.hide();
          reject(ex);
        }
      });
    }

    /**
     * Método que realiza una petición HTTP de tipo GET
     * ClaudiaFV
     * @param idPerfil
     * @param tipoDocumentoId
     * @param documentoId
     * @param tipoDocumentoIdPadre
     * @param documentoIdPadre
     * @param canalventaId
     * @param claveTemporal
     */
    ValidarPIN(idPerfil:string,tipoDocumentoId:string,documentoId:string,tipoDocumentoIdPadre:string,documentoIdPadre:string,canalventaId:string,claveTemporal:number) {
      return new Promise((resolve,reject) =>{ 
        try{
          this.get(`RecordarContraseña/ValidarClave?idPerfil=${idPerfil}&tipoDocumentoId=${tipoDocumentoId}&documentoId=${documentoId}&tipoDocumentoIdPadre=${tipoDocumentoIdPadre}&documentoIdPadre=${documentoIdPadre}&canalventaId=${canalventaId}&claveTemporal=${claveTemporal}`).subscribe(
              (response: any) => {
              resolve(response);
            })
        }
        catch (ex) {
          this.SpinnerService.hide();
          reject(ex);
          this.alertService.error(ex, false);
        }
      });
    }

    /**
     * Método que realiza una petición HTTP de tipo GET
     * ClaudiaFV
     * @param idPerfil
     * @param tipoDocumentoId
     * @param documentoId
     * @param tipoDocumentoIdPadre
     * @param documentoIdPadre
     * @param canalventaId
     */
    ConsultarCambioClave(idPerfil:string,tipoDocumentoId:string,documentoId:string,tipoDocumentoIdPadre:string,documentoIdPadre:string,canalventaId:string) {
      return new Promise((resolve,reject) =>{ 
        try{
          this.get(`RecordarContraseña/ConsultarCambioClave?idPerfil=${idPerfil}&tipoDocumentoId=${tipoDocumentoId}&documentoId=${documentoId}&tipoDocumentoIdPadre=${tipoDocumentoIdPadre}&documentoIdPadre=${documentoIdPadre}&canalventaId=${canalventaId}`).subscribe(
              (response: STResponse) =>{
              if(!response.error){  
                resolve(response);
              }else{
                reject(response);
              }
            },
            (exception)=>{ 
              
            }
            );
          } 
          catch(ex) {
            this.SpinnerService.hide();
            reject(ex);
          }
        });
    }
}